module.exports = __webpack_public_path__ + "img/user.93615eaf.png";